<html><head>
    <title>Formularios</title>
  </head>
  <body>
    <div class="container">
  <div class="jumbotron mt-3">
    <h1>Llenar formulario</h1>
    <p class="lead">Desde aqui podras llenar nuevos formularios.</p>
    <a routerLink="gettemplates" class="btn btn-lg btn-primary" role="button">Mostrar formularios disponibles »</a>
  </div>
  <div class="jumbotron mt-3">
    <h1>Mis formularios</h1>
    <p class="lead">Desde aqui podras ver tus formularios.</p>
    <a routerLink="getforms" class="btn btn-lg btn-primary" role="button">Ver mis formularios »</a>
  </div>
</div>
</body></html>